import { useEffect, useState } from 'react';
import { pagoService } from '../../services/api';
import '../../styles/Reportes.css';

const IngresosCapital = () => {
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [datos, setDatos] = useState(null);
  const [pagos, setPagos] = useState([]);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    // Establecer fechas por defecto (mes actual)
    const hoy = new Date();
    const primerDia = new Date(hoy.getFullYear(), hoy.getMonth(), 1);

    setFechaInicio(primerDia.toISOString().split('T')[0]);
    setFechaFin(hoy.toISOString().split('T')[0]);
  }, []);

  const cargarDatos = async () => {
    if (!fechaInicio || !fechaFin) {
      alert('Por favor selecciona ambas fechas');
      return;
    }

    setCargando(true);
    try {
      const response = await pagoService.getAll();
      const todosPagos = response.data.pagos || [];

      const inicio = new Date(fechaInicio);
      const fin = new Date(fechaFin);
      fin.setHours(23, 59, 59);

      // Filtrar pagos por fecha
      const pagosFiltrados = todosPagos.filter(p => {
        const fechaPago = new Date(p.fecha_pago);
        return fechaPago >= inicio && fechaPago <= fin;
      });

      // Calcular totales
      const totalCapital = pagosFiltrados.reduce((sum, p) => sum + (p.monto_capital || 0), 0);
      const totalInteres = pagosFiltrados.reduce((sum, p) => sum + (p.monto_interes || 0), 0);
      const totalMora = pagosFiltrados.reduce((sum, p) => sum + (p.monto_mora || 0), 0);
      const totalGeneral = pagosFiltrados.reduce((sum, p) => sum + p.monto_total, 0);

      // Agrupar por tipo de pago
      const porTipo = pagosFiltrados.reduce((acc, p) => {
        const tipo = p.tipo_pago || 'normal';
        if (!acc[tipo]) {
          acc[tipo] = {
            cantidad: 0,
            capital: 0,
            interes: 0,
            mora: 0,
            total: 0
          };
        }
        acc[tipo].cantidad++;
        acc[tipo].capital += p.monto_capital || 0;
        acc[tipo].interes += p.monto_interes || 0;
        acc[tipo].mora += p.monto_mora || 0;
        acc[tipo].total += p.monto_total;
        return acc;
      }, {});

      setDatos({
        totalCapital,
        totalInteres,
        totalMora,
        totalGeneral,
        porTipo,
        cantidad: pagosFiltrados.length
      });
      setPagos(pagosFiltrados);
    } catch (error) {
      alert('Error al cargar datos');
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-DO', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
  };

  const getNombreTipo = (tipo) => {
    const nombres = {
      'normal': 'Normal',
      'solo_interes': 'Solo Interés',
      'extraordinario': 'Extraordinario',
      'adelanto': 'Adelanto'
    };
    return nombres[tipo] || tipo;
  };

  return (
    <div className="reporte-detalle">
      <div className="reporte-header">
        <h1>� Ingresos de Capital</h1>
        <p>Detalle de capital recuperado vs intereses y mora</p>
      </div>

      <div className="filtros-container">
        <div className="filtro-grupo">
          <label>Fecha Inicial:</label>
          <input
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
            className="input-text"
          />
        </div>

        <div className="filtro-grupo">
          <label>Fecha Final:</label>
          <input
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
            className="input-text"
          />
        </div>

        <button onClick={cargarDatos} className="btn-buscar">
          Generar Reporte
        </button>
      </div>

      {cargando && (
        <div className="loading">Generando reporte de capital...</div>
      )}

      {!cargando && datos && (
        <>
          <div className="info-prestamo">
            <h3>Período: {formatearFecha(fechaInicio)} - {formatearFecha(fechaFin)}</h3>
            <div className="info-grid">
              <div><strong>Total Pagos:</strong> {datos.cantidad}</div>
              <div><strong>Total Recaudado:</strong> ${datos.totalGeneral.toFixed(2)}</div>
            </div>
          </div>

          <div className="resumen-cards">
            <div className="card-resumen" style={{ borderLeft: '4px solid #3498db' }}>
              <div className="card-icono">💰</div>
              <div className="card-info">
                <div className="card-valor" style={{ color: '#3498db' }}>
                  ${datos.totalCapital.toFixed(2)}
                </div>
                <div className="card-label">Capital Recuperado</div>
                <small>{((datos.totalCapital / datos.totalGeneral) * 100).toFixed(1)}% del total</small>
              </div>
            </div>

            <div className="card-resumen" style={{ borderLeft: '4px solid #27ae60' }}>
              <div className="card-icono">📈</div>
              <div className="card-info">
                <div className="card-valor" style={{ color: '#27ae60' }}>
                  ${datos.totalInteres.toFixed(2)}
                </div>
                <div className="card-label">Intereses Cobrados</div>
                <small>{((datos.totalInteres / datos.totalGeneral) * 100).toFixed(1)}% del total</small>
              </div>
            </div>

            <div className="card-resumen" style={{ borderLeft: '4px solid #e67e22' }}>
              <div className="card-icono">⚠️</div>
              <div className="card-info">
                <div className="card-valor" style={{ color: '#e67e22' }}>
                  ${datos.totalMora.toFixed(2)}
                </div>
                <div className="card-label">Mora Cobrada</div>
                <small>{((datos.totalMora / datos.totalGeneral) * 100).toFixed(1)}% del total</small>
              </div>
            </div>

            <div className="card-resumen" style={{ borderLeft: '4px solid #9b59b6' }}>
              <div className="card-icono">💵</div>
              <div className="card-info">
                <div className="card-valor" style={{ color: '#9b59b6' }}>
                  ${datos.totalGeneral.toFixed(2)}
                </div>
                <div className="card-label">Total General</div>
                <small>{datos.cantidad} pagos recibidos</small>
              </div>
            </div>
          </div>

          <div className="info-prestamo" style={{ marginTop: '30px' }}>
            <h3>� Distribución de Ingresos</h3>
            <div className="tabla-container">
              <table className="tabla-reporte">
                <thead>
                  <tr>
                    <th>Concepto</th>
                    <th>Monto</th>
                    <th>Porcentaje</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Capital</strong></td>
                    <td>${datos.totalCapital.toFixed(2)}</td>
                    <td>{((datos.totalCapital / datos.totalGeneral) * 100).toFixed(2)}%</td>
                  </tr>
                  <tr>
                    <td><strong>Interés</strong></td>
                    <td className="destacado">${datos.totalInteres.toFixed(2)}</td>
                    <td>{((datos.totalInteres / datos.totalGeneral) * 100).toFixed(2)}%</td>
                  </tr>
                  <tr>
                    <td><strong>Mora</strong></td>
                    <td>${datos.totalMora.toFixed(2)}</td>
                    <td>{((datos.totalMora / datos.totalGeneral) * 100).toFixed(2)}%</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr className="totales">
                    <td><strong>TOTAL</strong></td>
                    <td><strong>${datos.totalGeneral.toFixed(2)}</strong></td>
                    <td><strong>100%</strong></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

          {Object.keys(datos.porTipo).length > 0 && (
            <div className="info-prestamo" style={{ marginTop: '30px' }}>
              <h3>📋 Desglose por Tipo de Pago</h3>
              <div className="tabla-container">
                <table className="tabla-reporte">
                  <thead>
                    <tr>
                      <th>Tipo de Pago</th>
                      <th>Cantidad</th>
                      <th>Capital</th>
                      <th>Interés</th>
                      <th>Mora</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(datos.porTipo).map(([tipo, valores]) => (
                      <tr key={tipo}>
                        <td><strong>{getNombreTipo(tipo)}</strong></td>
                        <td>{valores.cantidad}</td>
                        <td>${valores.capital.toFixed(2)}</td>
                        <td className="destacado">${valores.interes.toFixed(2)}</td>
                        <td>${valores.mora.toFixed(2)}</td>
                        <td><strong>${valores.total.toFixed(2)}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr className="totales">
                      <td><strong>TOTALES</strong></td>
                      <td><strong>{datos.cantidad}</strong></td>
                      <td><strong>${datos.totalCapital.toFixed(2)}</strong></td>
                      <td className="destacado"><strong>${datos.totalInteres.toFixed(2)}</strong></td>
                      <td><strong>${datos.totalMora.toFixed(2)}</strong></td>
                      <td><strong>${datos.totalGeneral.toFixed(2)}</strong></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          )}

          <div className="info-prestamo" style={{ marginTop: '20px', background: '#e8f5e9' }}>
            <h3 style={{ color: '#2e7d32' }}>💎 Análisis de Rentabilidad</h3>
            <div className="info-grid">
              <div>
                <strong>Ganancia Bruta:</strong>
                <span style={{ color: '#2e7d32', fontSize: '1.2em', marginLeft: '10px' }}>
                  ${(datos.totalInteres + datos.totalMora).toFixed(2)}
                </span>
              </div>
              <div>
                <strong>ROI sobre Capital:</strong>
                <span style={{ fontSize: '1.2em', marginLeft: '10px' }}>
                  {datos.totalCapital > 0 ? (((datos.totalInteres + datos.totalMora) / datos.totalCapital) * 100).toFixed(1) : '0'}%
                </span>
              </div>
            </div>
          </div>
        </>
      )}

      {!cargando && !datos && (
        <div className="sin-datos">
          <p>Selecciona un período y genera el reporte</p>
        </div>
      )}
    </div>
  );
};

export default IngresosCapital;
